import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DefaultOpeningClosingLastCallHour } from 'src/shared/models/default-opening-closing-hour.interface';
import { ExtensionResponseDto } from 'src/shared/models/extension-response.interface';
import { environment } from '../../../../shared/infrastructure/environments/environment';
import { WorkingHourExtensions } from '../../../../shared/models/working-hours-extension.interface';

@Injectable({
    providedIn: 'root'
})
export class WorkingHoursExtensionsService {
    url: string = `${environment.backend_url}/api/v1/extension`;

    constructor(private readonly http: HttpClient) {
    }

    getWorkingHoursExtensions(): Observable<WorkingHourExtensions[]> {
        return this.http.get<WorkingHourExtensions[]>(`${this.url}`);
    }

    saveWorkingHoursExtension(extension: WorkingHourExtensions): Observable<WorkingHourExtensions> {
        return this.http.post<WorkingHourExtensions>(`${this.url}`, extension);
    }

    getWorkingHoursExtensionsConfig(): Observable<ExtensionResponseDto> {
        return this.http.get<ExtensionResponseDto>(`${this.url}/config`);
    }

    getDefaultOpeningAndClosingHours(): Observable<DefaultOpeningClosingLastCallHour> {
        return this.http.get<DefaultOpeningClosingLastCallHour>(`${environment.backend_url}/api/v1/macro-slot/default-opening-closing-hour`);
    }

    deleteWorkingHoursExtension(id: number): Observable<void | string> {
      return this.http.delete<string>(`${this.url}/${id}`);
    }

}
